<template>
    <div class="StaffDensity">
        <Title firstName="人员密集度统计[日]" lastName="PERSONNEL DENSITY" />
        <div class="echarts">
        <div id="StaffDensity" ref="echarts" style="height: 28vh;" />
        <!-- <div class="build"><span></span>昌华办公楼<span></span></div> -->
        <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import("../../../../components/title/Title");
import * as echarts from "echarts";
let myChart = null
export default {
	data() {
		return {

		};
	},
	components: {
		Title,
	},
    mounted() {
      	this.initCharts();
      	window.addEventListener('resize',this.chartResize)
        window.addEventListener('beforeunload', this.clearChart);
    },
  
	beforeDestroy() {
		if (!myChart) {
		return;
		}
		myChart.dispose();
		myChart = null;
	},
  	methods: {
		clearChart(){
            // 手动触发 destroy 相关的生命周期
            this.$destroy();
        },
        chartResize(){
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                myChart.resize();
            },500)
        },
    	initCharts() {
			var chartDom = document.getElementById("StaffDensity");
			myChart = echarts.init(chartDom);

			myChart = echarts.getInstanceByDom(document.getElementById("StaffDensity"));
            if(myChart == null){
                myChart = echarts.init(document.getElementById("StaffDensity"));
            }

      var option;
      const dataBJ = [
        [55, 9, 56, 0.46, 18, 6, 1],
        [25, 11, 21, 0.65, 34, 9, 2],
        [56, 7, 63, 0.3, 14, 5, 3],
        [33, 7, 29, 0.33, 16, 6, 4],
        [42, 24, 44, 0.76, 40, 16, 5],
        [82, 58, 90, 1.77, 68, 33, 6],
        [74, 49, 77, 1.46, 48, 27, 7],
        [78, 55, 80, 1.29, 59, 29, 8],
        [267, 216, 280, 4.8, 108, 64, 9],
        [185, 127, 216, 2.52, 61, 27, 10],
        [39, 19, 38, 0.57, 31, 15, 11],
        [41, 11, 40, 0.43, 21, 7, 12],
        [64, 38, 74, 1.04, 46, 22, 13],
        [108, 79, 120, 1.7, 75, 41, 14],
        [108, 63, 116, 1.48, 44, 26, 15],
        [33, 6, 29, 0.34, 13, 5, 16],
        [94, 66, 110, 1.54, 62, 31, 17],
        [186, 142, 192, 3.88, 93, 79, 18],
        [57, 31, 54, 0.96, 32, 14, 19],
        [22, 8, 17, 0.48, 23, 10, 20],
        [39, 15, 36, 0.61, 29, 13, 21],
        [94, 69, 114, 2.08, 73, 39, 22],
        [99, 73, 110, 2.43, 76, 48, 23],
        [31, 12, 30, 0.5, 32, 16, 24],
        [42, 27, 43, 1, 53, 22, 25],
        [154, 117, 157, 3.05, 92, 58, 26],
        [234, 185, 230, 4.09, 123, 69, 27],
        [160, 120, 186, 2.77, 91, 50, 28],
        [134, 96, 165, 2.76, 83, 41, 29],
        [52, 24, 60, 1.03, 50, 21, 30],
        [46, 5, 49, 0.28, 10, 6, 31],
      ];
      const lineStyle = {
        width: 1,
        opacity: 0.5,
      };
      option = {
        radar: {
            indicator: [
                { name: "18:00", max: 300 },
                { name: "22:00", max: 250 },
                { name: "2:00", max: 300 },
                { name: "6:00", max: 5 },
                { name: "10:00", max: 200 },
                { name: "14:00", max: 100 },
            ],
            shape: "circle",
            splitNumber: 5,
            axisName: {
                color: "#f0f0f0",
            },
            splitLine: {
                lineStyle: {
                color: [
                    "rgba(52, 141, 240, 0.1)",
                    "rgba(52, 141, 240, 0.2)",
                    "rgba(52, 141, 240, 0.4)",
                    "rgba(52, 141, 240, 0.6)",
                    "rgba(52, 141, 240, 0.8)",
                    "rgba(52, 141, 240, 1)",
                ].reverse(),
                },
            },
            splitArea: {
                show: false,
            },
            axisLine: {
                lineStyle: {
                color: "rgba(238, 197, 102, 0.5)",
                },
            },
            },
            series: [
            {
                name: "Shanghai",
                type: "radar",
                lineStyle: lineStyle,
                data: dataBJ,
                symbol: "none",
                itemStyle: {
                color: "#5B8FF9",
                },
                areaStyle: {
                opacity: 0.05,
                },
            },
            ],
        };

        option && myChart.setOption(option);
      
    	},
  	},
	beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!myChart) return 
        myChart.clear()
        myChart = null;
    }
};
</script>

<style lang="less" scoped>
.StaffDensity {
    // height: 33.3vh;
    width: 20vw;
    position: fixed;
    top: 62vh;
    left: 2vw;
    z-index: 1;

    .echarts {
        position: relative;
        height: 31vh;
        padding-bottom: 1vh;
        padding-top: 1vh;
        background: linear-gradient(
        0deg,
        rgba(0, 33, 59, 0.6) 0%,
        rgba(3, 13, 24, 0.7) 100%
        );

        .build{
            height: 2vh;
            line-height: 2vh;
            text-align: center;
            font-size: 16rem;
            color: rgba(255, 255, 255, .7);
            &>span{
                width: 0;
                height: 0;
                display: inline-block;
                border: 6rem solid transparent;
                border-top: 5rem solid transparent;
                border-bottom: 5rem solid transparent;
                margin: 0 1vw;
            }
            &>span:nth-of-type(1){
                border-right: 6rem solid #fff;
            }
            &>span:nth-of-type(2){
                border-left: 6rem solid #fff;
            }
        }

        .bottom {
        width: 20vw;
        height: 1vh;
        background: url(../../../../assets/img/板块装饰线.png) no-repeat;
        block-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        }
    }
}
</style>
